import { TThunkAction } from '../../../types/redux';
import { getRegionFailed } from './getRegionFailed';
import { getRegionLoading } from './getRegionLoading';
import { getRegionSucceed } from './getRegionSucceed';
import { fetchRegion } from '../../../services/region/fetchRegion';
import { prepareRegion } from '../../../utils/prepareRegion';

export const getRegion = (regionId: number): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const {
      httpApi,
      logger,
      custom: { subdomain },
    } = context;

    dispatch(getRegionLoading());

    const response = await fetchRegion(
      { httpApi, logger },
      {
        regionId,
        subdomain,
      },
    );

    if (response !== null) {
      dispatch(getRegionSucceed(prepareRegion(response)));
    } else {
      dispatch(getRegionFailed());
    }
  };
};
